<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-img
              v-if="serviceData"
              alt="Flexline logo"
              style="border-radius: 10%;"
              flex
              @click="orderDetailsDialog = true"
              :src="serviceData.serviceProviderMedia"/>
<!--        <div>{{serviceData.serviceProviderName}}</div>-->
        </v-flex>

      </v-layout>
      <v-dialog v-model="orderDetailsDialog"
                ref="dialog"
                persistent
                fullscreen
      >

        <v-card v-if="serviceData">

          <v-card-title>
            <v-avatar
                class="mt-2"
                size="72px"
                tile

            >
              <img
                  alt="Avatar"
                  :src="serviceData.serviceProviderMedia"
                  style="border-radius: 10%;"
              >
            </v-avatar>
          </v-card-title>
          <v-card-subtitle v-if="serviceData.linkType === 'instructions'">
            <div class="white black--text
                    text-xs-center
                    font-weight-regular mt-6">
            </div>
          </v-card-subtitle>
          <v-card-subtitle v-else>
            <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1 mt-6">
              Mission Plan</div>
            <div class="font-weight-regular">From: {{serviceData.serviceProviderName}}</div>
          </v-card-subtitle>
          <v-card-text >
            <div class="subtitle-1">Date & Time</div>
            <v-divider></v-divider>
            <div class="subtitle-1"></div>
            <v-card-title class="headline" v-if="serviceData">
              <v-icon>event</v-icon>{{serviceData.serviceDate}}
            </v-card-title>
            <v-card-title
                v-if="serviceData">
              <v-icon>schedule</v-icon>
              <div>Start time: </div>
              <div  class="headline">
                {{serviceData.meetUpTime}}
              </div>

            </v-card-title>
            <v-card-subtitle
                class="subtitle-1"
                v-if="serviceData">
              Estimated finish:
              {{serviceData.estimatedFinishTime}}
            </v-card-subtitle>
          </v-card-text>

          <v-card-text v-if="serviceData.routeDetails">
            <div class="subtitle-1">Trip Locations</div>
            <v-divider></v-divider>
            <div class="subtitle-1"></div>
          </v-card-text>
          <v-card-text v-if="serviceData.routeDetails">
            <v-row  v-if="serviceData.routeDetails.meetUpLocation">
              <v-card-text>
                <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + serviceData.routeDetails.meetUpLocation.formatted_address">
                  <div><v-icon class="red--text">location_pin</v-icon> {{serviceData.routeDetails.meetUpLocation.formatted_address}}</div>
                </a>
              </v-card-text>
            </v-row>
            <v-row>
              <v-list v-if="serviceData.routeDetails.locations">
                <v-list-item v-if="serviceData.routeDetails.locations.length === 0">
                  <v-list-item-avatar><v-icon>add_location</v-icon></v-list-item-avatar>
                  <v-list-item-content>
                    No locations
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-for="local in serviceData.routeDetails.locations" :key="local.created">
                  <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + local.formatted_address">
                    <div><v-icon class="red--text">location_pin</v-icon> {{local.formatted_address}}</div>
                  </a>
                </v-list-item>
              </v-list>
            </v-row>
          </v-card-text>

          <v-card-text v-if="serviceData.payoutDetails">
            <div class="subtitle-1">Payout Details</div>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-if="serviceData.payoutDetails">
            <v-row>
              <v-col>
                <div>Service Required:</div>
              </v-col>
              <v-col>
                {{serviceData.payoutDetails.serviceRequired}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>{{serviceData.payoutDetails.text}}</v-col>
            </v-row>
          </v-card-text>


          <v-card-text v-if="serviceData.instructions">
            <div class="subtitle-1">Instructions</div>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-if="serviceData.instructions">
            <v-row v-for="(step, i) in serviceData.instructions" :key="i">
              <v-col>
                <div>{{step}}</div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions v-if="!serviceData.instructions">
            <v-btn text outlined @click="orderDetailsDialog = false" block>close</v-btn>
<!--            <v-btn @click="handleChatPill" outlined class="blue&#45;&#45;text">-->
<!--              Preview text</v-btn>-->
          </v-card-actions>
          <v-card-actions>
<!--            <v-btn class="blue&#45;&#45;text" outlined block @click="routeServiceProver">Count me in!</v-btn>-->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import {doc, onSnapshot} from "firebase/firestore";
// import moment from moment
export default {
  name: "postedService",
  props: ['serviceProviderId', 'linkId'],
  data: () => ({
    serviceData: null,
    orderDetailsDialog: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    this.$store.dispatch('setLoading', true)
    console.log(this.user)
    console.log(this.serviceProviderId)
    console.log(this.linkId)
    let db = this.$store.state.db
    let invoiceRef = doc(db, 'services', this.serviceProviderId, 'postedServices', this.linkId)
    onSnapshot(invoiceRef, res => {
      if (res.exists) {
        this.serviceData = res.data()
        console.log(res.data())
        this.$store.dispatch('setLoading', false)
        this.orderDetailsDialog = true
      }
    })
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    routeServiceProver () {
      // this.$store.dispatch('initCardPayment', paymentObj)
      //path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      return this.$router.push(
          '/checkSmsAuth/'
          + this.serviceProviderId
          + '/providerCheck'
          + '/checkIn/'
          + this.linkId
      )
    }
  }

}
</script>

